import { EntityType } from '@frontend/common';
import { AsyncComponent } from '@frontend/components/common';
import { NodeType } from '@frontend/group/types';
import { CommonMessage } from '@frontend/lang';
import { lazy } from 'react';
import { FormattedMessage } from 'react-intl';

import { useWizardModalScreenNavigation } from '../../wizard-modal-navigation.context';
import useEnterProductCategory from './enter-product-category.controller';

const ID = 'wizard-enter-product-category';
const MultiGroupSelect = lazy(() => import('@frontend/group/select').then((module) => ({ default: module.MultiGroupSelect })));

const EnterProductCategory = (props: { wizard_id: string }) => {
    const viewProps = useEnterProductCategory(props);

    useWizardModalScreenNavigation({
        onContinue: viewProps.onSubmit,
        continueDisabled: false
    });

    return (
        <div
            id={ID}
            className='flex w-full flex-col gap-4'>
            <div className='text-foreground-default text-base font-medium'>
                <FormattedMessage
                    id='platform.wizard.enter-product-category.heading'
                    description='Heading shown on the platform create product wizard product category screen'
                    defaultMessage='Select one or more categories'
                />
            </div>

            <div className='outline-border-default rounded-xl p-4 outline-1'>
                <AsyncComponent>
                    <MultiGroupSelect
                        id={ID}
                        type={EntityType.PRODUCT_CATEGORY}
                        label={CommonMessage.OBJECTS.CATEGORY.PLURAL}
                        value={viewProps.categoryIds}
                        onChange={viewProps.setCategoryIds}
                        queryParams={{ node_type: [NodeType.BRANCH, NodeType.ROOT] }}
                        isClearable
                    />
                </AsyncComponent>
            </div>
        </div>
    );
};

export default EnterProductCategory;
